<template>
  <div class="page-outbox">
  	<!--预付款金额信息-->
    <div class="prepay-info-box">
      <div class="prepay-body">
        <div class="prepay-title">
          金额
        </div>
        <div class="prepay-money">￥{{$store.state.subOrderInfo.so_total}}</div>
        <p class="order-num">订单号:{{$store.state.subOrderInfo.so_no}}</p>
      </div>

    </div>
    <!--订单金额信息-->
    <div class="order-price-box" v-if="$store.state.userInfo.cus_chk_type!='1'&&$store.state.userInfo.cus_if_pre=='1'">
      <label>预付款金额:</label>
      <span>￥{{$store.state.subOrderInfo.cus_prepay}}</span>
    </div>
    <!--提交按钮-->
    <div class="opr-btn-group">
      <mt-button size="large" class="green" @click="selectPayType('wechat')"
                 v-if="$store.state.userInfo.cus_chk_type!='1'&&$store.state.userInfo.cus_if_pre!='1'&&$store.state.subOrderInfo.so_ci_method!='3'">微信支付</mt-button>
      <mt-button size="large" class="blue" :disabled="!canPrePay"
                 @click="selectPayType('prepay')"
                 v-if="$store.state.userInfo.cus_chk_type!='1'&&$store.state.userInfo.cus_if_pre=='1'">{{canPrePay?'预付支付':'余额不足'}}</mt-button>
      <mt-button size="large" class="yellow" @click="selectPayType('offline')">线下支付</mt-button>
    </div>
    <!--线下支付-->
    <div class="pay-offline-tips">
      <p>公司名称：上海易恩化学技术有限公司<br/>
        账号：3100 6930 9018 8000 03232<br/>
        开户行：交通银行上海南桥支行<br/>
        注：汇款时敬请在汇款用途栏或附言栏中填入您的订单号，以便我们核对并确保您的订单能够及时发货。
      </p>
    </div>
  </div>
</template>

<script>
	export default {
    name: 'panyInfo',
    data () {
      return {
        orderNum:''
      }
    },
    computed:{
      canPrePay(){
        return this.$store.state.subOrderInfo.so_total<this.$store.state.subOrderInfo.cus_prepay
      }
    },
    methods:{
      selectPayType(type){
        if(type=='wechat'){
          this.$messagebox.alert('温馨提示','请至罗恩微信公众号在线商城支付！');
        }else if(type=='offline'){
          this.$toast('线下支付');
          this.$router.replace({path:'/OrderList'});
        } else if (type == 'prepay') {
          if (this.$store.state.subOrderInfo.so_total > this.$store.state.subOrderInfo.cus_prepay) {
            return;
          }
          this.$cHttp.post('orders/prepay', {
            partner:this.$systemConfig.partner,
            apikey:this.$systemConfig.apikey,
            user_id:this.$store.state.userInfo.user_id,
            so_id:this.$store.state.subOrderInfo.so_id
          }).then((res)=>{
            console.log(res);
          if (res.status && res.status == 1) {
            this.$toast('支付成功');
            //更新预存款
            this.$store.commit('setSubOrderInfo',{
              cus_prepay:this.$store.state.subOrderInfo.cus_prepay-this.$store.state.subOrderInfo.so_total,
              so_no:'',
              so_id:'',
              so_total:0,
              so_ci_method:''
            })
            this.$router.replace({path:'/OrderList'});
          } else {
            this.$toast(res.error_msg)
          }
        }).catch((msg)=>{
            this.$toast(msg);
        })
        }
      }
    },
    components:{

    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .page-outbox{
    background-color: #e7fbf4;
    background-color: $mainColor-light4;
  }
  .prepay-info-box{
    display: flex;
    align-items: center;
    width: 100%;
    height: 1.6rem;
    background: url(../../assets/pay-bg-3.jpg) no-repeat center;
    background-size:cover;
    .prepay-body{
      margin: 0 auto;
      text-align: center;
      color: #fff;
      .prepay-title{
        padding-top: .4rem;
        font-size: .15rem;
        background: url(../../assets/prepay-icon.png) no-repeat center top;
        background-size: .36rem .36rem;
        opacity: .8;
      }
      .prepay-money{
        padding-top: .1rem;
        font-size: .18rem;
        font-weight: bold;
      }
      .order-num{
        padding-top:.15rem;
        font-size:.13rem;
        color:#eee;
      }
    }
  }
  .pay-offline-tips{
    padding: .15rem;
    padding-top: .25rem;
    font-size:.14rem;
    line-height: .23rem;
    color: $warningColor;
    font-weight:700;
  }
  .order-price-box{
    display: flex;
    padding: .1rem;
    font-size: .15rem;
    line-height: .2rem;
    background-color: #fff;
    >label{
      color: #999;
    }
    >span{
      flex: 1;
      text-align: right;
      color: $mainColor;
      font-weight: bold;
    }
  }
  .opr-btn-group{
    padding: .3rem .2rem .15rem;
    .mint-button{
      margin-bottom: .15rem;
      font-size: .15rem;
      color: #fff;
      border:none;
      background-color: #17b6fa;
      background-color: #fbd914;
     /* &.green{
        background-color: #32ed1f;
      }
      &.yellow{
        background-color: #efd325;
      }
      &.blue{
        background-color: #29bcff;
      }*/
      &:active{
        background-color: #17aaec;
        background-color: #fbce23;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payInfo/payInfo.vue